"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineWithSections = void 0;
const react_1 = __importStar(require("react"));
const shared_video_player_video_section_1 = require("@guidde-co/shared.video-player.video-section");
function TimelineWithSections({ sections = [], videoElement }) {
    const duration = (videoElement === null || videoElement === void 0 ? void 0 : videoElement.duration) || 0;
    // fallback if there are no chapters
    if (!sections.length) {
        const sectionType = {
            start: 0,
            end: duration,
            title: ''
        };
        sections = [sectionType];
    }
    const formattedSections = [
        { rangeValues: [0, 0], start: 0, end: 0, title: '' },
        ...sections === null || sections === void 0 ? void 0 : sections.map(section => {
            const start = (section.start / duration) * 100 || 0;
            const end = (section.end / duration) * 100;
            return Object.assign(Object.assign({}, section), { rangeValues: [start, end] });
        }),
        { rangeValues: [100, 100], start: 0, end: 0, title: '' } // last one is hidden, to be in the same format as edit mode
    ];
    const updateTimeByPercentage = (0, react_1.useCallback)((percentage) => {
        if (videoElement) {
            videoElement.currentTime = (duration / 100) * percentage || 0;
            return;
        }
    }, [duration, videoElement]);
    if (!videoElement)
        return null;
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            display: 'flex',
            backgroundColor: 'transparent'
        } }, formattedSections === null || formattedSections === void 0 ? void 0 : formattedSections.map((section, idx) => {
        return (react_1.default.createElement(shared_video_player_video_section_1.VideoSection, { key: idx, index: idx, sections: formattedSections, onUpdateTime: updateTimeByPercentage, videoElement: videoElement }));
    })));
}
exports.TimelineWithSections = TimelineWithSections;
//# sourceMappingURL=timeline-with-sections.js.map